import React, { useContext, useState } from "react";

import { Alert, DialogContentText, Snackbar } from "@mui/material";

import { syncUserData } from "api/endpoints/external-syncs";
import { callOptionsHeaders } from "api/helpers";
import ConfirmDialog from "components/shared/confirm-dialog";
import { DEFAULT_SNACKBAR_DURATION } from "constants/index";
import { SnackbarContext } from "context/snackbar-context";
import { UserContext } from "context/user-context";

interface ConfirmUserSyncDialogProps {
  userId: string;
  regionCode: string;
  open: boolean;
  setOpen: (newOpen: boolean) => void;
}

const ConfirmUserSyncDialog = ({
  userId,
  regionCode,
  open,
  setOpen,
}: ConfirmUserSyncDialogProps) => {
  const [successOpen, setSuccessOpen] = useState(false);
  const { showError } = useContext(SnackbarContext);

  const { user } = useContext(UserContext);
  const userName = `${user?.firstName ?? "N/A"} ${user?.lastName ?? ""}`;
  const userOrg = user?.orgId ?? "N/A";
  const userEmail = user?.email ?? "N/A";

  const handleSendButtonPress = () => {
    syncUserData(
      {
        userId: userId,
        organisationId: userOrg,
        name: userName,
        email: userEmail,
      },
      callOptionsHeaders(regionCode, userId),
    )
      .then(() => {
        setSuccessOpen(true);
      })
      .catch((error) => {
        showError(error);
      });
  };

  return (
    <>
      <ConfirmDialog
        title="Confirm Sync User"
        open={open}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Sync"
        setOpen={setOpen}
        onConfirm={handleSendButtonPress}
      >
        <DialogContentText>
          This will attempt to sync basic user information to external services.
          Do you want to continue?
        </DialogContentText>
      </ConfirmDialog>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={successOpen}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={() => setSuccessOpen(false)}
        data-testid="confirm-user-sync-dialog-success"
      >
        <Alert severity="success" variant="filled">
          User Synced Confirmed
        </Alert>
      </Snackbar>
    </>
  );
};
export default ConfirmUserSyncDialog;
